export const bidiotvMoviesGH=[
    {
        id: 1,
        contents: 7,
        name: {
          en: "",
          gh:""
        },
        videos: [{
            duration: 'Watch Now',
            id: 100,
            name: 'Africa fusion',
            preview: 'https://cdn.mobiotv.com/gh/Africa+fusion.png',
            desc: '',
            videoUrl: ''
          },
          {
            duration: 'Watch Now',
            id: 101,
            name: 'Antarctica - Tales from the end of the world',
            preview: 'https://cdn.mobiotv.com/gh/Antarctica+-+Tales+from+the+end+of+the+world.png',
            desc: '',
            videoUrl: ''
          },
          {
            duration: 'Watch Now',
            id: 102,
            name: 'Chadar - The ice trial',
            preview: 'https://cdn.mobiotv.com/gh/Chadar+-+The+ice+trial.png',
            desc: '',
            videoUrl: ''
          },
          {
            duration: 'Watch Now',
            id: 103,
            name: 'Ethiopia by tuk tuk',
            preview: 'https://cdn.mobiotv.com/gh/Ethiopia+by+tuk+tuk.png',
            desc: '',
            videoUrl: ''
          },
          {
            duration: 'Watch Now',
            id: 104,
            name: 'Giants with mud feet',
            preview: 'https://cdn.mobiotv.com/gh/Giants+with+mud+feet.png',
            desc: '',
            videoUrl: ''
          },
          {
            duration: 'Watch Now',
            id: 105,
            name: 'Hunan - The other world of Avatar',
            preview: 'https://cdn.mobiotv.com/gh/Hunan+-+The+other+world+of+Avatar.png',
            desc: '',
            videoUrl: ''
          },
          {
            duration: 'Watch Now',
            id: 106,
            name: 'Moonflower',
            preview: 'https://cdn.mobiotv.com/gh/Moonflower.png',
            desc: '',
            videoUrl: ''
          },
        ]
    },
    {
        id: 2,
        contents: 7,
        name: {
          en: "",
          gh:""
        },
        videos: [
            {
                duration: 'Watch Now',
                id: 200,
                name: 'Omo child',
                preview: 'https://cdn.mobiotv.com/gh/Omo+child.png',
                desc: '',
                videoUrl: ''
            },
            {
                duration: 'Watch Now',
                id: 201,
                name: 'Scars - Politics in the big blue',
                preview: 'https://cdn.mobiotv.com/gh/Scars+-+Politics+in+the+big+blue.png',
                desc: '',
                videoUrl: ''
            },
            {
                duration: 'Watch Now',
                id: 202,
                name: 'Sealers - One last hunt',
                preview: 'https://cdn.mobiotv.com/gh/Sealers+-+One+last+hunt.png',
                desc: '',
                videoUrl: ''
            },
            {
                duration: 'Watch Now',
                id: 203,
                name: 'Siam - The elephant',
                preview: 'https://cdn.mobiotv.com/gh/Siam+-+The+elephant.png',
                desc: '',
                videoUrl: ''
            },
            {
                duration: 'Watch Now',
                id: 204,
                name: 'The long road of Tokyo',
                preview: 'https://cdn.mobiotv.com/gh/The+long+road+of+Tokyo.png',
                desc: '',
                videoUrl: ''
            },
            {
                duration: 'Watch Now',
                id: 205,
                name: 'Unbounded - A journey into Patagonia',
                preview: 'https://cdn.mobiotv.com/gh/Unbounded+-+A+journey+into+Patagonia.png',
                desc: '',
                videoUrl: ''
            },
            {
                duration: 'Watch Now',
                id: 206,
                name: 'Wadi rum',
                preview: 'https://cdn.mobiotv.com/gh/Wadi+rum.png',
                desc: '',
                videoUrl: ''
            },
        ]
    }

]


// WEBPACK FOOTER //
// ./src/constants/bannerDetails_gh.js